import { AttachmentPreviewMethod, AttachmentSelectionSource } from 'owa-attachment-data';
import { lazyGetAttachment } from 'owa-attachment-model-store';
import { SaveToCloudStatus } from 'owa-attachment-savetocloud';
import { ClientAttachmentId, isClientAttachmentIdEqual } from 'owa-client-ids';
import { isStringNullOrWhiteSpace } from 'owa-localize';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import { PreviewPaneMode } from 'owa-sxsdata';
import { mutator } from 'satcheljs';
import {
    internalCloseSxS,
    onAttachmentIdUpdate,
    setSaveToCloudStatus,
} from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';
import { onChangeByImageGallery, reloadTextPreview } from '../actions/publicLazyActions';
import getOrCreateSxSStoreData from '../store/Store';
import tryGetAttachmentFullViewStateByIdInReadingPane from '../utils/tryGetAttachmentFullViewStateByIdInReadingPane';
import { isAttachmentOfReferenceType } from 'owa-attachment-type/lib/isAttachmentOfReferenceType';

mutator(showSxS, actionMessage => {
    const { extendedViewState, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).extendedViewState = extendedViewState;
});

mutator(internalCloseSxS, actionMessage => {
    const { sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).extendedViewState = {
        previewMode: AttachmentPreviewMethod.Unsupported,
        attachmentId: null,
        selectionSource: AttachmentSelectionSource.MailList,
        isCloudy: false,
        saveToCloudStatus: SaveToCloudStatus.disabled,
        textPreviewReadMode: GetAttachmentTextPreviewReadMode.AutoDetect,
    };
});

mutator(onChangeByImageGallery, actionMessage => {
    const { sxsId } = actionMessage;
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (sxsStore.viewState.previewPane.mode === PreviewPaneMode.Image) {
        const getAttachment = lazyGetAttachment.tryImportForRender();
        if (getAttachment) {
            const currentAttachmentId: ClientAttachmentId = sxsStore.viewState.previewPane.id;
            const attachmentModel = getAttachment(currentAttachmentId);

            sxsStore.extendedViewState.attachmentId = currentAttachmentId;
            sxsStore.extendedViewState.isCloudy =
                attachmentModel?.model && isAttachmentOfReferenceType(attachmentModel.model);

            let isSaveToCloudSupported = false;
            if (attachmentModel?.model && !attachmentModel.model.IsInline) {
                const attachmentViewState = tryGetAttachmentFullViewStateByIdInReadingPane(
                    currentAttachmentId,
                    sxsId
                );
                const isSaveToCloudSupportedInStrategy =
                    attachmentViewState?.strategy?.isSaveToCloudSupported;
                isSaveToCloudSupported =
                    isSaveToCloudSupportedInStrategy &&
                    isStringNullOrWhiteSpace(attachmentModel.model.AttachmentOriginalUrl);
            }
            const saveToCloudStatus = isSaveToCloudSupported
                ? SaveToCloudStatus.available
                : SaveToCloudStatus.disabled;
            sxsStore.extendedViewState.saveToCloudStatus = saveToCloudStatus;
        }
    }
});

mutator(onAttachmentIdUpdate, actionMessage => {
    const { attachmentId, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).extendedViewState.attachmentId = attachmentId;
});

mutator(setSaveToCloudStatus, actionMessage => {
    const { attachmentId, saveToCloudStatus, sxsId } = actionMessage;
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    if (isClientAttachmentIdEqual(sxsStore.extendedViewState.attachmentId, attachmentId)) {
        sxsStore.extendedViewState.saveToCloudStatus = saveToCloudStatus;
    }
});

mutator(reloadTextPreview, actionMessage => {
    const { readMode, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).extendedViewState.textPreviewReadMode = readMode;
});
